import React from 'react';
import NotFound from '../views/NotFound';

interface PrivateRouteProps {
  element: JSX.Element;
  permission?: string;
  requiredRole?: string;
  blockedRole?: string;
}

type Role = {
  name?: string;
};

const readStorageArray = <T,>(key: string): T[] => {
  try {
    const value = localStorage.getItem(key);
    const parsed = JSON.parse(value || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.error(`${key} parse hatası`, e);
    return [];
  }
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, permission, requiredRole, blockedRole }) => {
  let userPermissions: string[] = [];
  let userRoles: Role[] = [];

  userPermissions = readStorageArray<string>('permissions');
  userRoles = readStorageArray<Role>('roles');

  const hasPermission = !permission || userPermissions.includes(permission);
  const hasRequiredRole = !requiredRole || userRoles.some((role) => role?.name === requiredRole);
  const hasBlockedRole = Boolean(blockedRole && userRoles.some((role) => role?.name === blockedRole));

  if (hasPermission && hasRequiredRole && !hasBlockedRole) {
    return element;
  } else {
    return <NotFound />;
  }
};

export default PrivateRoute;
